import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesAutoSafe,
    useStylesAutoBlack,
} from '../../../St/Reports/UseStyle';
//=====================================================================
import { useTranslation } from "react-i18next";
import { SaleCheckbox, useStylesContainers } from '../../../St/comps/UseStyle';
import { Button, ButtonBase, colors, Container, Divider, FormControlLabel, Hidden } from '@material-ui/core';
import ReceiptVoucherType from '../../Accounts/BackEnd/receipt-voucher/components/ReceiptVoucher-typeFilter';
import { sto } from '../../../Context/InshData';
import { GetItemFromOptions } from '../../../services/global-services';
import SalaryFilter from '../employeesSalary/SalaryFilter';
import RestInfoDialog from '../../Invs/BackEnd/models/RestInfo/RestInfoDialog';

export default function EmployeeAdvancesForm(props) {

    const {
        AutoOptions,
        params,
        valueAutos,
        years,
        months,
        onChange,
        onChangeAuto,
        setParams,
        setValueAutos,
        branch,
        AdvancesState,
        prevent,
        costCenters,
    } = props;

    const clasASafe = useStylesAutoSafe();

    const clsConts = useStylesContainers();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasBalck = useStylesAutoBlack();
    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);

    const valuebranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches ?? []);
    const [infoData, setInfoData] = useState({ open: false });

    return (
        <React.Fragment>
            <Grid container justifyContent="center" spacing={2} className={[clsConts.rootup]}>
                <Grid
                    item
                    container
                    spacing={1}
                    lg={12} md={12} sm={12} xs={12}
                >

                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameA"
                            label={t("no")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                            type="number"
                            name="no"
                            value={params.no}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={branch.id == -1 ? valuebranch : branch}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                onChangeAuto("branch", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Branches}
                            disabled={!prevent ? true : sto.User_typei == 1 ? false : true}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:branch")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.emp}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                onChangeAuto("emp", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Employees}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{ background: colors.blueGrey[50] }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:employee")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>


                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.emp_resp}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                onChangeAuto("emp_resp", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Employees}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("responsible-employee")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>


                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <TextField
                            fullWidth
                            className={clasTF.rootCust}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            variant="outlined"
                            size="small"
                            id="date"
                            label={t("date")}
                            type="date"
                            format="YYYY-MM-DD"
                            name="datef"
                            value={params.date}
                            onChange={onChange("date")}
                        />
                    </Grid>


                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.center}
                            onChange={(event, newValue) => {
                                onChangeAuto("center", newValue);
                            }}
                            id="combo-box-demo"
                            size="small"
                            options={costCenters}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                    label={t("center")}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.month}
                            onChange={(event, newValue) => {
                                onChangeAuto("month", newValue);
                            }}
                            id="combo-box-demo"
                            size="small"
                            options={months}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                    label={t("month")}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.year}
                            onChange={(event, newValue) => {
                                onChangeAuto("year", newValue);
                            }}
                            id="combo-box-demo"
                            size="small"
                            options={years}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                    label={t("year")}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginTop: "1rem" }}>
                        <Divider style={{ background: '#4a82b9', height: 1.5 }} />
                        <Divider
                            style={{ background: '#4a82b9', marginTop: 3, height: 1.5 }}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginTop: "0.9rem" }}>
                        <SalaryFilter
                            {...{
                                params,
                                setParams,
                                onChange,
                                AutoOptions,
                                valueAutos,
                                setValueAutos
                            }}
                        />
                    </Grid>
                    {params.type == "1" ?
                        (
                            <Grid item lg={5} md={5} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                                <Autocomplete
                                    classes={clasBalck}
                                    value={valueAutos.safe_bank_id}
                                    onChange={(event, newValue) => {
                                        onChangeAuto("safe_bank_id", newValue);
                                    }}
                                    id="combo-box-demo"
                                    size="small"
                                    options={AutoOptions.Stocks}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    style={{ backgroundColor: colors.red[50] }}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                            label={t("stock")}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                        )
                        :
                        (
                            <Grid item lg={5} md={5} sm={5} xs={6} style={{ marginTop: "0.9rem" }}>
                                <Autocomplete
                                    classes={clasBalck}
                                    value={valueAutos.safe_bank_id}
                                    onChange={(event, newValue) => {
                                        onChangeAuto("safe_bank_id", newValue);
                                    }}
                                    id="combo-box-demo"
                                    size="small"
                                    options={AutoOptions.Banks}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    style={{ backgroundColor: colors.red[50] }}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                            label={t("account")}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                        )
                    }

                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.state}
                            onChange={(event, newValue) => {
                                onChangeAuto("state", newValue);
                            }}
                            id="combo-box-demo"
                            size="small"
                            options={AdvancesState}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable={true}
                            disabled={prevent == false ? false : true}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                    label={t("advance-status")}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>


                    <Grid item lg={4} md={4} sm={4} xs={6} style={{ marginTop: "0.9rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Address"
                            label={t("amount")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            style={{ backgroundColor: colors.blueGrey[50] }}
                            InputProps={{ className: claslbl.clrBlackLblS, }}
                            type="number"
                            name="amount"
                            value={params?.amount}
                            onChange={onChange("amount")}
                        />
                    </Grid>
                    <br />
                    <br />

                    <Grid item lg={!prevent ? 11 : 12} md={!prevent ? 11 : 12} sm={!prevent ? 11 : 12} xs={12} style={{ marginTop: "1rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="notes"
                            label={t("notes")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="text"
                            name="notes"
                            multiline
                            value={params.notes}
                            onChange={onChange("notes")}
                        />
                    </Grid>
                    {!prevent &&
                        (
                            <Grid item lg={1} md={1} sm={1} xs={1} style={{ marginTop: "1rem" }}>
                                <Hidden only={["xs"]}>
                                    <Button
                                        fullWidth
                                        autoFocus
                                        variant="contained"
                                        color="#000"
                                        onClick={(e) => {
                                            setInfoData({ open: true, })
                                        }}
                                        style={{
                                            background: colors.grey[300],
                                            ...{
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                            },
                                        }}
                                    >
                                        {t("entry") + "  "}
                                    </Button>
                                </Hidden>
                            </Grid>
                        )}

                    {!prevent && (
                        <RestInfoDialog
                            infoData={infoData}
                            setInfoData={setInfoData}
                            res_id={params.rest_id}
                            branch={params.branch}
                            fromInv={0}
                            proc_id={0}
                        />
                    )}
                    <Grid item lg={5} md={5} sm={5} xs={12} style={{ paddingBottom: "0.9rem" }}>

                    </Grid>


                </Grid>
            </Grid>

        </React.Fragment>
    );

}